import React, { useEffect, useState } from "react";

import { connect } from "react-redux";

import { Switch, Link, Route, useRouteMatch } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";

import PasswordReset from "./PasswordReset";

import firebase from "../../services/firebase";
import trackingService from "../../services/tracking";
import { PRIVACY_POLICY_LINK, TERMS_LINK } from "../../constants";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
  },
  textField: {
    margin: theme.spacing(1, 0),
  },
  root: {
    margin: theme.spacing(2, 2),
    padding: theme.spacing(3, 2),
  },
  button: {
    margin: theme.spacing(1, 0),
  },
}));

export const LoginPage = ({ user }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const classes = useStyles();
  const match = useRouteMatch();

  const errorCodeMap = {
    "auth/user-not-found":
      "There is no account with that email address. Please create an account.",
    "auth/wrong-password": (
      <>
        Invalid password. Please try again or{" "}
        <Link to="/a/login/reset/">reset your password</Link>.
      </>
    ),
    "auth/email-already-in-use": (
      <>
        An account has already been created with this email address. Please
        Login or <Link to="/a/login/reset/">reset your password</Link>.
      </>
    ),
  };

  useEffect(() => {
    const ruleName = "isPasswordMatch";
    ValidatorForm.addValidationRule(ruleName, (value) => value === password);
    return () => ValidatorForm.removeValidationRule(ruleName);
  }, [password]);

  // todo: should probably dedupe the two following functions

  const handleSignUp = async () => {
    try {
      await firebase.auth().createUserWithEmailAndPassword(email, password);
      trackingService.logEvent("create_account", { email });
    } catch (error) {
      console.log("firebase auth error: ", error);
      setError(error);
    }
  };
  const handleLogin = async () => {
    try {
      await firebase.auth().signInWithEmailAndPassword(email, password);
      trackingService.logEvent("login", { email });
    } catch (error) {
      console.log("firebase auth error: ", error);
      setError(error);
    }
  };
  const handleKeyDown = (event) => {
    debugger;
  };

  return (
    <Paper className={classes.root}>
      <Switch>
        <Route exact path={`${match.path}`}>
          <Typography variant="h5">Login</Typography>
          <Typography component="p">
            Login or sign up to get on top of you transactions today!
          </Typography>
          <ValidatorForm className={classes.container}>
            <TextValidator
              autoFocus
              className={classes.textField}
              id="name"
              label="Email Address"
              onChange={(event) => setEmail(event.target.value)}
              type="email"
              variant="outlined"
              margin="normal"
              fullWidth
              value={email}
              validators={["required", "isEmail"]}
              errorMessages={["this field is required", "must be valid email"]}
            />
            <TextValidator
              id="standard-password-input"
              label="Password"
              className={classes.textField}
              type="password"
              autoComplete="current-password"
              margin="normal"
              variant="outlined"
              onChange={(event) => setPassword(event.target.value)}
              value={password}
              validators={["required", "matchRegexp:.{6,}"]}
              errorMessages={[
                "this field is required",
                "must have 6 characters",
              ]}
              onKeyDown={handleKeyDown}
            />
            {error && (
              <Typography component="p" color="error">
                {errorCodeMap[error.code]
                  ? errorCodeMap[error.code]
                  : error.message}
              </Typography>
            )}
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleLogin}
              className={classes.button}
              type="submit"
            >
              Login
            </Button>
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              onClick={handleSignUp}
              className={classes.button}
              type="submit"
            >
              Start Free Trial
            </Button>
            <Typography>
              By creating an account, you agree to our{" "}
              <a target="_new" href={TERMS_LINK}>
                Terms
              </a>
              , and{" "}
              <a target="_new" href={PRIVACY_POLICY_LINK}>
                Privacy Policy
              </a>
              .
            </Typography>
          </ValidatorForm>
        </Route>
        <Route path={`${match.path}/reset`}>
          <PasswordReset />
        </Route>
      </Switch>
    </Paper>
  );
};

const mapStateToProps = (state) => ({ user: state.firebase.auth });

export default connect(mapStateToProps)(LoginPage);
